import { createFileRoute } from '@tanstack/react-router';
import { GroupServicesPage } from '@/features/currency/group-services-page';

export const Route = createFileRoute('/_app/settings/groups/$id')({
  component: GroupServicesPage,
});
